import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faLinkedinIn, faXTwitter, faFacebookF, faYoutube, faWhatsapp, faInstagram } from '@fortawesome/free-brands-svg-icons';
import './footer.css'; // Import the prefixed CSS file
import logo from "./2.png"


// Updated Placeholder SVG Logo for NowNFC
const TechLogo = ({ color = "var(--footernfc-accent-primary-unique, #007BFF)", size = 40 }) => (
  <svg width={size * 3.7} height={size} viewBox="0 0 148 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 0L0 10V30L20 40L40 30V10L20 0Z" fill={color} fillOpacity="0.8"/>
      <path d="M15 5L5 10V30L15 35L35 25V15L15 5Z" fill="#1D2A3B"/>
      <path d="M20 10L10 15V25L20 30L30 25V15L20 10Z" fill={color}/>
      <text x="48" y="27" fontFamily="Montserrat, sans-serif" fontSize="20" fontWeight="bold" fill={color}>
          Now<tspan fillOpacity="0.7">NFC</tspan>
      </text>
  </svg>
);


// Enhanced Unique Footer Component for Lite Theme
const UniqueFooter = () => {
  const currentYear = new Date().getFullYear();
  const brandPhoneNumber = "94608910765";
  const displayPhoneNumber = "+91-9119115535";


  return (
      <footer className="footernfc-site-footer-unique footernfc-lite-theme">
          <div className="footernfc-footer-angle-top-lite"></div>
          <div className="footernfc-footer-container-unique">


              <div className="footernfc-footer-main-unique">
                  <div className="footernfc-footer-column-unique footernfc-footer-company-col-unique">
                      <div className="footernfc-footer-logo-unique">
                          <img  className='footernfc-footerlogo' src={logo} alt="" srcset="" />
                      </div>
                      <p className="footernfc-footer-description-unique">
                          Pioneering Near Field Communication, NowNFC connects your world, one tap at a time. Innovative solutions for a seamless future.
                      </p>
                   
                  </div>


                  <div className="footernfc-footer-column-unique footernfc-footer-links-col-unique">
                      <h4>Explore NowNFC</h4>
                      <ul>
                          <li><a href="/">Home</a></li>
                          <li><a href="/about">Our Story</a></li>
                          <li><a href="/pricing">Pricing</a></li>
                          <li><a href="/features">NowNFC Innovations</a></li>
                          <li><a href="/contact">Connect Now</a></li>
                      </ul>
                  </div>


                  <div className="footernfc-footer-column-unique footernfc-footer-links-col-unique">
                      <h4>Applications</h4>
                      <ul>
                          <li><a href="#smart-cards">Intelligent Cards</a></li>
                          <li><a href="#tap-pay">Seamless Payments</a></li>
                          <li><a href="#access">Fluid Access Control</a></li>
                          <li><a href="#iot">IoT Integration</a></li>
                          <li><a href="#experiential">Interactive Experiences</a></li>
                      </ul>
                  </div>


                  <div className="footernfc-footer-column-unique footernfc-footer-contact-col-unique">
                      <h4>Get In Touch</h4>
                      <ul className="footernfc-contact-info-unique">
                          <li><FontAwesomeIcon icon={faEnvelope} /><a href="mailto:namaste@nownfc.com">namaste@nownfc.com</a></li>
                          <li><FontAwesomeIcon icon={faPhone} /><a href={`tel:+91${brandPhoneNumber}`}>{displayPhoneNumber}</a></li>
                          
                                 <div className="footernfc-social-media-icons-unique">
                          <a href="https://instagram.com/nownfcofficial" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                          <a href="https://linkedin.com/company/nownfcofficial" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faLinkedinIn} /></a>
                          <a href={`https://wa.me/91${brandPhoneNumber}`} aria-label="WhatsApp" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faWhatsapp} /></a>
                          <a href="https://youtube.com/@NowNFCofficial" aria-label="YouTube" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faYoutube} /></a>
                          <a href="https://facebook.com/nownfcofficial" aria-label="Facebook" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faFacebookF} /></a>
                      </div>
                         
                      </ul>
                  </div>
              </div>


              <div className="footernfc-footer-bottom-unique">
                  <p>© {currentYear} NowNFC Technologies. All Rights Reserved. Crafted with <span className="footernfc-heart-emoji">💡</span> in India.</p>
                  <p>
                      <a href="/privacy">Privacy Policy</a> | <a href="/terms">Terms of Service</a>
                  </p>
              </div>
          </div>
      </footer>
  );
};


export default UniqueFooter;